import {
  CasualTournamentDetails,
  CasualTournamentEntity,
  EventSchedule,
  Game,
  Location,
  TournamentPass,
  User,
} from '@fantaz/shared/data-access/models';
import { createAction, createActionGroup, props } from '@ngrx/store';

/**
 * Play tournament start action
 */
export const playTournament = createAction(
  '[PlayTournament] Play Tournament',
  props<{
    // TODO: load tournament details
    entryAmount: number;
    pass?: TournamentPass | string | null | undefined;
    zboOnly?: boolean;
    game: Game;
    openTournament: CasualTournamentDetails | CasualTournamentEntity;
    eventSchedule: EventSchedule;
  }>(),
);

/**
 * Play tournament success action
 */
export const playTournamentSuccess = createAction(
  '[PlayTournament] Play Tournament Success',
  props<{
    entryAmount: number;
    pass?: TournamentPass | string | null | undefined;
    zboOnly?: boolean;
    game: Game;
    user: User;
    eventCode?: string;
    openTournament: CasualTournamentDetails | CasualTournamentEntity;
    eventSchedule: EventSchedule;
    userLocation?: {
      deviceGPS?: Location | null;
      userAllowToUseFallbackLocation?: boolean | null;
    };
  }>(),
);

/**
 * Play tournament failure action
 */
export const playTournamentFailure = createAction(
  '[PlayTournament] Play Tournament Failure',
  props<{ error?: Error | string | null; payload?: any }>(),
);

export const playTournamentValidateUser = createAction(
  '[PlayTournament] Play Tournament Validate User',
  props<{ tournamentId: string }>(),
);

export const playTournamentValidateLocation = createAction(
  '[PlayTournament] Play Tournament Validate User',
  props<{ tournamentId: string }>(),
);

export const BuyPassToContinue = createActionGroup({
  source: '[PlayTournament] Buy Pass',
  events: {
    'Buy Pass': (payload: {
      pass: TournamentPass;
      tournament: {
        entryAmount: number;
        zboOnly?: boolean;
        game: Game;
        openTournament: CasualTournamentDetails | CasualTournamentEntity;
        eventSchedule: EventSchedule;
      };
    }) => ({ payload }),
  },
});
